// extracted by css-extract-rspack-plugin
export default {"Bar":"Bar--QshSU","BarContentLabel":"BarContentLabel--eCr75","BarDetailLabel":"BarDetailLabel--aDUW0","BarDetailIcon":"BarDetailIcon--KRBiW","BarFill":"BarFill--T67ao"};